// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"482":"9b56afd4","797":"4f034e44"}[chunkId] + ".css";
};